import React, { useEffect, useState } from 'react';
import './Hero.css';
import { trackSectionView, trackButtonClick, trackScrollDepth, trackDeviceType } from '../utils/analytics';

const Hero: React.FC = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);

      // Track scroll depth
      const scrollPercent = Math.round((window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100);
      if (scrollPercent > 0 && scrollPercent % 25 === 0) {
        trackScrollDepth(scrollPercent);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Track initial page load
    trackSectionView('Hero');
    trackDeviceType();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="hector-hero" id="home" itemScope itemType="https://schema.org/Person">
      <div
        className="hero-background"
        style={{
          transform: `translateY(${scrollY * 0.5}px)`,
        }}
      >
        <div className="celestial-moon"></div>
        <div className="celestial-sun"></div>
        <div className="hero-stars">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="star"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
              }}
            />
          ))}
        </div>
      </div>

      <div className="hero-content">
        <div className="hero-badge">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L13.5 7.5L19 9L13.5 10.5L12 15L10.5 10.5L5 9L10.5 7.5L12 2Z" fill="currentColor"/>
          </svg>
          <span>Master Artist</span>
        </div>
        <h1 className="hector-hero-title" itemProp="name">
          The Life & Vision of
          <span className="hero-name-highlight">Hector Díaz</span>
        </h1>
        <p className="hero-description-elegant" itemProp="description">
          Transforming downtown Tacoma through profound exploration of light, shadow, and celestial wonder
        </p>
        <div className="hero-cta">
          <button className="cta-button primary" onClick={() => document.getElementById('biography')?.scrollIntoView({ behavior: 'smooth' })}>
            <span className="button-icon">📖</span>
            Discover His Story
          </button>
          <button className="cta-button secondary" onClick={() => document.getElementById('gallery')?.scrollIntoView({ behavior: 'smooth' })}>
            <span className="button-icon">🖼️</span>
            View Gallery
          </button>
          <button className="cta-button tertiary" onClick={() => document.getElementById('artistic-career')?.scrollIntoView({ behavior: 'smooth' })}>
            <span className="button-icon">✨</span>
            Artistic Journey
          </button>
          <button className="cta-button quaternary" onClick={() => document.getElementById('articles')?.scrollIntoView({ behavior: 'smooth' })}>
            <span className="button-icon">📰</span>
            Read Articles
          </button>
        </div>
      </div>

      {/* Call to Action for Videos */}
      <div className="hero-video-cta">
        <div className="video-cta-card">
          <h3>Watch Hector's Story</h3>
          <p>Discover his community impact through media coverage and testimonials</p>
          <button className="video-cta-button" onClick={() => document.getElementById('videos')?.scrollIntoView({ behavior: 'smooth' })}>
            📺 View Videos
          </button>
        </div>
      </div>

      <div className="hero-scroll-indicator">
        <div className="scroll-arrow"></div>
        <span>Scroll to explore</span>
      </div>
    </section>
  );
};

export default Hero;